import { render } from "./TemplateSelection.vue?vue&type=template&id=f08094fe&scoped=true"
import script from "./TemplateSelection.vue?vue&type=script&lang=ts"
export * from "./TemplateSelection.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-f08094fe"

export default script